/**
 * Memecraft Sans — a proportional pixel font. Cap height 7, x-height 5, two descender rows.
 * Glyphs are authored as strings ('#' ink, '.' empty) so they can be read and tuned by eye.
 * Digits share one width (tabular) so HP / PP / coins columns line up.
 */
const G: Record<string, string> = {
  A: ".###.|#...#|#...#|#####|#...#|#...#|#...#",
  B: "####.|#...#|#...#|####.|#...#|#...#|####.",
  C: ".###.|#...#|#....|#....|#....|#...#|.###.",
  D: "####.|#...#|#...#|#...#|#...#|#...#|####.",
  E: "#####|#....|#....|####.|#....|#....|#####",
  F: "#####|#....|#....|####.|#....|#....|#....",
  G: ".###.|#...#|#....|#.###|#...#|#...#|.####",
  H: "#...#|#...#|#...#|#####|#...#|#...#|#...#",
  I: "###|.#.|.#.|.#.|.#.|.#.|###",
  J: "....#|....#|....#|....#|#...#|#...#|.###.",
  K: "#...#|#..#.|#.#..|##...|#.#..|#..#.|#...#",
  L: "#....|#....|#....|#....|#....|#....|#####",
  M: "#...#|##.##|#.#.#|#.#.#|#...#|#...#|#...#",
  N: "#...#|##..#|#.#.#|#..##|#...#|#...#|#...#",
  O: ".###.|#...#|#...#|#...#|#...#|#...#|.###.",
  P: "####.|#...#|#...#|####.|#....|#....|#....",
  Q: ".###.|#...#|#...#|#...#|#.#.#|#..#.|.##.#",
  R: "####.|#...#|#...#|####.|#.#..|#..#.|#...#",
  S: ".###.|#...#|#....|.###.|....#|#...#|.###.",
  T: "#####|..#..|..#..|..#..|..#..|..#..|..#..",
  U: "#...#|#...#|#...#|#...#|#...#|#...#|.###.",
  V: "#...#|#...#|#...#|#...#|.#.#.|.#.#.|..#..",
  W: "#...#|#...#|#...#|#.#.#|#.#.#|##.##|#...#",
  X: "#...#|#...#|.#.#.|..#..|.#.#.|#...#|#...#",
  Y: "#...#|#...#|.#.#.|..#..|..#..|..#..|..#..",
  Z: "#####|....#|...#.|..#..|.#...|#....|#####",
  a: ".....|.....|.###.|....#|.####|#...#|.####",
  b: "#....|#....|####.|#...#|#...#|#...#|####.",
  c: "....|....|.###|#...|#...|#...|.###",
  d: "....#|....#|.####|#...#|#...#|#...#|.####",
  e: ".....|.....|.###.|#...#|#####|#....|.###.",
  f: "..##|.#..|####|.#..|.#..|.#..|.#..",
  g: ".....|.....|.####|#...#|#...#|#...#|.####|....#|.###.",
  h: "#....|#....|####.|#...#|#...#|#...#|#...#",
  i: "#|.|#|#|#|#|#",
  j: "..#|...|..#|..#|..#|..#|..#|..#|##.",
  k: "#...|#...|#..#|#.#.|##..|#.#.|#..#",
  l: "#.|#.|#.|#.|#.|#.|.#",
  m: ".....|.....|####.|#.#.#|#.#.#|#.#.#|#.#.#",
  n: "....|....|###.|#..#|#..#|#..#|#..#",
  o: ".....|.....|.###.|#...#|#...#|#...#|.###.",
  p: ".....|.....|####.|#...#|#...#|#...#|####.|#....|#....",
  q: ".....|.....|.####|#...#|#...#|#...#|.####|....#|....#",
  r: "....|....|#.##|##..|#...|#...|#...",
  s: "....|....|.###|#...|.##.|...#|###.",
  t: ".#.|.#.|###|.#.|.#.|.#.|..#",
  u: "....|....|#..#|#..#|#..#|#..#|.###",
  v: ".....|.....|#...#|#...#|#...#|.#.#.|..#..",
  w: ".....|.....|#...#|#...#|#.#.#|#.#.#|.#.#.",
  x: ".....|.....|#...#|.#.#.|..#..|.#.#.|#...#",
  y: "....|....|#..#|#..#|#..#|#..#|.###|...#|.##.",
  z: "....|....|####|...#|.##.|#...|####",
  "0": ".###.|#...#|#..##|#.#.#|##..#|#...#|.###.",
  "1": "..#..|.##..|..#..|..#..|..#..|..#..|.###.",
  "2": ".###.|#...#|....#|..##.|.#...|#....|#####",
  "3": ".###.|#...#|....#|..##.|....#|#...#|.###.",
  "4": "...#.|..##.|.#.#.|#..#.|#####|...#.|...#.",
  "5": "#####|#....|####.|....#|....#|#...#|.###.",
  "6": ".###.|#....|#....|####.|#...#|#...#|.###.",
  "7": "#####|....#|...#.|..#..|..#..|..#..|..#..",
  "8": ".###.|#...#|#...#|.###.|#...#|#...#|.###.",
  "9": ".###.|#...#|#...#|.####|....#|....#|.###.",
  " ": "..|..|..|..|..|..|..",
  ".": ".|.|.|.|.|.|#",
  ",": "..|..|..|..|..|..|.#|#.",
  "!": "#|#|#|#|#|.|#",
  "?": ".###.|#...#|....#|..##.|..#..|.....|..#..",
  ":": ".|.|#|.|.|.|#",
  ";": "..|..|.#|..|..|..|.#|#.",
  "-": "....|....|....|####|....|....|....",
  "+": ".....|.....|..#..|..#..|#####|..#..|..#..",
  "=": "....|....|####|....|####|....|....",
  "/": "....#|...#.|...#.|..#..|.#...|.#...|#....",
  "'": "#|#|.|.|.|.|.",
  "\"": "#.#|#.#|...|...|...|...|...",
  "(": ".#|#.|#.|#.|#.|#.|.#",
  ")": "#.|.#|.#|.#|.#|.#|#.",
  "[": "##|#.|#.|#.|#.|#.|##",
  "]": "##|.#|.#|.#|.#|.#|##",
  $: "..#..|.####|#.#..|.###.|..#.#|####.|..#..",
  "%": "##..#|##.#.|...#.|..#..|.#...|.#.##|#..##",
  "&": ".##..|#..#.|#.#..|.#...|#.#.#|#..#.|.##.#",
  "*": ".....|..#..|#.#.#|.###.|#.#.#|..#..|.....",
  "#": ".....|.#.#.|#####|.#.#.|#####|.#.#.|.....",
  "<": "...#|..#.|.#..|#...|.#..|..#.|...#",
  ">": "#...|.#..|..#.|...#|..#.|.#..|#...",
  _: ".....|.....|.....|.....|.....|.....|.....|#####",
  "|": "#|#|#|#|#|#|#|#",
  "~": ".....|.....|.....|.##.#|#..#.|.....|.....",
  "^": "..#..|.#.#.|#...#|.....|.....|.....|.....",
  "@": ".###.|#...#|#.###|#.#.#|#.##.|#....|.###.",
  "·": ".|.|.|#|.|.|.",
  "×": ".....|.....|#...#|.#.#.|..#..|.#.#.|#...#",
  "▶": "#...|##..|###.|####|###.|##..|#...",
  "◀": "...#|..##|.###|####|.###|..##|...#",
  "▼": ".......|.......|#######|.#####.|..###..|...#...|.......",
  "▲": ".......|...#...|..###..|.#####.|#######|.......|.......",
  "♥": ".....|##.##|#####|#####|.###.|..#..|.....",
  "★": "..#..|..#..|#####|.###.|.#.#.|#...#|.....",
  "✓": ".....|....#|...#.|#.#..|.#...|.....|.....",
  "◆": ".....|..#..|.###.|#####|.###.|..#..|.....",
  "•": "...|...|###|###|###|...|...",
  "✦": "..#..|..#..|.###.|#####|.###.|..#..|..#..",
  "→": ".....|..#..|...#.|#####|...#.|..#..|.....",
};

interface Glyph {
  w: number;
  rows: Uint8Array; // bitmask per row, bit (w-1-col)
  h: number;
}

const glyphs = new Map<string, Glyph>();
for (const [ch, def] of Object.entries(G)) {
  const lines = def.split("|");
  const w = lines[0]!.length;
  const rows = new Uint8Array(lines.length);
  lines.forEach((line, y) => {
    let bits = 0;
    for (let x = 0; x < w; x++) if (line[x] === "#") bits |= 1 << (w - 1 - x);
    rows[y] = bits;
  });
  glyphs.set(ch, { w, rows, h: lines.length });
}

const FALLBACK = glyphs.get("?")!;

function glyph(ch: string): Glyph {
  const hit = glyphs.get(ch);
  if (hit) return hit;
  // Accented letters fall back to their base form.
  const base = ch.normalize("NFD").replace(/[̀-ͯ]/g, "");
  return glyphs.get(base) ?? glyphs.get(base.toUpperCase()) ?? FALLBACK;
}

/** Legacy cell width, kept for code that still estimates widths in fixed cells. */
export const FONT_W = 6;
/** Default line advance in pixels. */
export const FONT_H = 11;
export const CAP_H = 7;
export const SPACING = 1;

/** Width in pixels of `text` at `scale`, without trailing spacing. */
export function measureText(text: string, scale = 1): number {
  let w = 0;
  let best = 0;
  for (const ch of text) {
    if (ch === "\n") {
      best = Math.max(best, w - SPACING);
      w = 0;
      continue;
    }
    w += glyph(ch).w + SPACING;
  }
  return Math.max(best, w - SPACING, 0) * scale;
}

export type Rgba4 = readonly [number, number, number, number];

/**
 * Draw `text` into `img`. Returns the y below the last line. Honours an optional clip rectangle and
 * scale (integer). `wrap` > 0 wraps at that pixel width on spaces.
 */
export function drawText(
  img: ImageData,
  x: number,
  y: number,
  text: string,
  color: Rgba4,
  wrap = 0,
  scale = 1,
  clip?: { x0: number; y0: number; x1: number; y1: number },
  lineH = FONT_H,
): number {
  const lines = wrap > 0 ? wrapPx(text, wrap / scale) : text.split("\n");
  const w = img.width;
  const data = img.data;
  const cx0 = clip ? clip.x0 : 0;
  const cy0 = clip ? clip.y0 : 0;
  const cx1 = clip ? clip.x1 : w;
  const cy1 = clip ? clip.y1 : img.height;
  const a = color[3] / 255;
  const ia = 1 - a;
  let cy = y;
  for (const line of lines) {
    let cx = x;
    for (const ch of line) {
      const gl = glyph(ch);
      for (let row = 0; row < gl.h; row++) {
        const bits = gl.rows[row]!;
        if (!bits) continue;
        for (let col = 0; col < gl.w; col++) {
          if (((bits >> (gl.w - 1 - col)) & 1) === 0) continue;
          for (let sy = 0; sy < scale; sy++) {
            const py = cy + row * scale + sy;
            if (py < cy0 || py >= cy1) continue;
            for (let sx = 0; sx < scale; sx++) {
              const px = cx + col * scale + sx;
              if (px < cx0 || px >= cx1) continue;
              const o = (py * w + px) * 4;
              if (a >= 1) {
                data[o] = color[0];
                data[o + 1] = color[1];
                data[o + 2] = color[2];
              } else {
                data[o] = color[0] * a + data[o]! * ia;
                data[o + 1] = color[1] * a + data[o + 1]! * ia;
                data[o + 2] = color[2] * a + data[o + 2]! * ia;
              }
              data[o + 3] = 255;
            }
          }
        }
      }
      cx += (gl.w + SPACING) * scale;
    }
    cy += lineH * scale;
  }
  return cy;
}

/** Word-wrap to a pixel width (at scale 1). Explicit newlines are kept. */
export function wrapPx(text: string, maxW: number): string[] {
  const out: string[] = [];
  for (const para of text.split("\n")) {
    const words = para.split(" ");
    let line = "";
    for (const word of words) {
      const next = line ? `${line} ${word}` : word;
      if (measureText(next) > maxW && line) {
        out.push(line);
        line = word;
      } else {
        line = next;
      }
    }
    out.push(line);
  }
  return out;
}

/** Legacy column wrap (fixed cells). */
export function wrapLines(text: string, cols: number): string[] {
  return wrapPx(text, cols * FONT_W);
}

/** Trim `text` with an ellipsis-free cut so it fits `maxW` pixels. */
export function fitText(text: string, maxW: number): string {
  if (measureText(text) <= maxW) return text;
  let s = text;
  while (s.length > 1 && measureText(`${s}.`) > maxW) s = s.slice(0, -1);
  return `${s}.`;
}
